import { promotionService } from '../services'

const state = {
    promotions: {
        loading: false,
        rows: []
    },
    createPromotion: {
        loading: false,
    },
    busy: false
}

const actions = {

    getAll ({ dispatch, commit }, params) {
        commit('getPromotionsRequest')
        promotionService.getAll(params).then(
            response => {
                commit('getPromotionsSuccess', response)
            },
            error => {
                commit('getPromotionsError')
                dispatch('alert/error', 'Unable to load promotions: ' + error, { root: true })
            }
        )
    },

    createPromotion({ dispatch, commit }, params) {
        commit('startCreatePromotionRequest')
        promotionService.createPromotion(params).then(
            response => {
                commit('endCreatePromotionRequest')
                dispatch('alert/success', 'New Promotion created successfully', { root: true })

                dispatch('getPromotions', {})
            },
            error => {
                commit('endCreatePromotionError')
                dispatch('alert/error', 'Unable to create new promotion: ' + error, { root: true })
            }
        )
    },

    deletePromotion({ dispatch, commit }, id) {
        commit('startCreatePromotionRequest')
        promotionService.deletePromotion(id).then(
            response => {
                commit('endCreatePromotionRequest')
                dispatch('alert/success', 'Promotion deleted successfully', { root: true })
                dispatch('getPlans', {})
            },
            error => {
                commit('endCreatePromotionError')
                dispatch('alert/error', 'Unable to delete promotion: ' + error, { root: true })
            }
        )
    },

}

const mutations = {
    getPromotionsRequest (state) {
        state.promotions = { loading: true, rows: [] }
    },
    getPromotionsSuccess (state, data) {
        state.promotions = { loading: false, total: data.total, rows: data.rows }
    },
    getPromotionsError (state) {
        state.promotions = { loading: false, total: 0, rows: [] }
    },
    startCreatePromotionRequest (state) {
        state.createPromotion = { loading: true }
    },
    endCreatePromotionRequest (state) {
        state.createPromotion = { loading: false }
    },
    endCreatePromotionError (state) {
        state.createPromotion = { loading: false }
    },
}

const getters = {
    isLoadingPromotions (state) {
        return state.promotions.loading === true
    },
    getPromotions (state) {
        return state.promotions.rows
    },
    getPromotionsLength (state) {
        return state.promotions.rows.length
    },
    isBusy (state) {
        return state.createPromotion.loading === true || state.promotions.loading === true
    },
}

export const promotionModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
